import { html } from "fxjs/es";
import { v4 as uuidv4 } from "uuid";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import {
  makeActiveColor,
  makeActiveColor2,
} from "../../../../../../Util/color.js";
export const initDOM = (self) => {
  const canvas_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "svg"
  );
  canvas_el.style.backgroundColor = "#F8F9FA";
  canvas_el.setAttributeNS(null, "x", "0");
  canvas_el.setAttributeNS(null, "y", "0");
  canvas_el.setAttributeNS(null, "width", "0");
  canvas_el.setAttributeNS(null, "height", "0");
  canvas_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "canvas";
  self._canvas_el = canvas_el;
  const dummy_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  dummy_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "dummy";
  canvas_el.appendChild(dummy_g_el);
  self._dummy_g_el = dummy_g_el;
  const layers_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "svg"
  );
  layers_el.setAttributeNS(null, "x", "0");
  layers_el.setAttributeNS(null, "y", "0");
  layers_el.setAttributeNS(null, "width", "0");
  layers_el.setAttributeNS(null, "height", "0");
  layers_el.setAttributeNS(null, "preserveAspectRatio", "xMidYMid meet");
  layers_el.setAttributeNS(null, "viewBox", "0 0 0 0");
  layers_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "layers";
  canvas_el.appendChild(layers_el);
  self._layers_el = layers_el;
  const art_board_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  art_board_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "art-boards";
  layers_el.appendChild(art_board_layer_el);
  self._art_board_layer_el = art_board_layer_el;
  const background_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  background_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "background-layer";
  layers_el.appendChild(background_layer_el);
  self._background_layer_el = background_layer_el;
  const working_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  working_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "working-layer";
  layers_el.appendChild(working_layer_el);
  self._working_layer_el = working_layer_el;
  const foreground_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  foreground_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "foreground-layer";
  layers_el.appendChild(foreground_layer_el);
  self._foreground_layer_el = foreground_layer_el;
  const rubber_band_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  rubber_band_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "rubber-band-layer";
  layers_el.appendChild(rubber_band_layer_el);
  self._rubber_band_layer_el = rubber_band_layer_el;
  const path_editor_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  path_editor_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "path-editor-layer";
  layers_el.appendChild(path_editor_layer_el);
  self._path_editor_layer_el = path_editor_layer_el;
  const {
    art_board_rect_el,
    art_board_filter_drop_shadow_el,
    art_board_clip_path_el,
    art_board_clip_path_rect_el,
  } = (() => {
    const art_board_defs_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "defs"
    );
    art_board_layer_el.appendChild(art_board_defs_el);
    const art_board_filter_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "filter"
    );
    art_board_filter_el.setAttributeNS(
      null,
      "id",
      `${CommonNS.ConstNS.DATA_KEY_ROLE}__art-board-filter__${uuidv4()}`
    );
    art_board_filter_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
      "art-board-filter";
    art_board_defs_el.appendChild(art_board_filter_el);
    const art_board_filter_drop_shadow_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "feDropShadow"
    );
    art_board_filter_drop_shadow_el.setAttributeNS(null, "dx", "0");
    art_board_filter_drop_shadow_el.setAttributeNS(null, "dy", "0");
    art_board_filter_drop_shadow_el.setAttributeNS(null, "stdDeviation", "0");
    art_board_filter_drop_shadow_el.setAttributeNS(
      null,
      "flood-color",
      "#000000"
    );
    art_board_filter_drop_shadow_el.setAttributeNS(
      null,
      "flood-opacity",
      "0.05"
    );
    art_board_filter_el.appendChild(art_board_filter_drop_shadow_el);
    const art_board_clip_path_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "clipPath"
    );
    art_board_clip_path_el.setAttributeNS(
      null,
      "id",
      `${CommonNS.ConstNS.DATA_KEY_ROLE}__art-board-clip-path__${uuidv4()}`
    );
    art_board_defs_el.appendChild(art_board_clip_path_el);
    const art_board_clip_path_rect_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "rect"
    );
    art_board_clip_path_rect_el.setAttributeNS(null, "x", "0");
    art_board_clip_path_rect_el.setAttributeNS(null, "y", "0");
    art_board_clip_path_rect_el.setAttributeNS(null, "width", "0");
    art_board_clip_path_rect_el.setAttributeNS(null, "height", "0");
    art_board_clip_path_el.appendChild(art_board_clip_path_rect_el);
    const art_board_rect_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "rect"
    );
    art_board_rect_el.setAttributeNS(null, "x", "0");
    art_board_rect_el.setAttributeNS(null, "y", "0");
    art_board_rect_el.setAttributeNS(null, "width", "0");
    art_board_rect_el.setAttributeNS(null, "height", "0");
    art_board_rect_el.setAttributeNS(null, "fill", "#FFFFFF");
    art_board_rect_el.setAttributeNS(
      null,
      "filter",
      `url(#${art_board_filter_el.id})`
    );
    art_board_rect_el.setAttributeNS(null, "stroke", "#E9ECEF");
    art_board_rect_el.setAttributeNS(null, "stroke-width", "0");
    art_board_rect_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "art-board";
    art_board_layer_el.appendChild(art_board_rect_el);
    return {
      art_board_rect_el,
      art_board_filter_drop_shadow_el,
      art_board_clip_path_el,
      art_board_clip_path_rect_el,
    };
  })();
  self._art_board_rect_el = art_board_rect_el;
  self._art_board_filter_drop_shadow_el = art_board_filter_drop_shadow_el;
  self._art_board_clip_path_el = art_board_clip_path_el;
  self._art_board_clip_path_rect_el = art_board_clip_path_rect_el;
  const background_base_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "rect"
  );
  background_base_el.setAttributeNS(null, "x", "0");
  background_base_el.setAttributeNS(null, "y", "0");
  background_base_el.setAttributeNS(null, "width", "0");
  background_base_el.setAttributeNS(null, "height", "0");
  background_base_el.setAttributeNS(null, "fill", "#FFFFFF");
  background_base_el.setAttributeNS(null, "stroke", "none");
  background_base_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "background-base";
  background_layer_el.appendChild(background_base_el);
  self._background_base_el = background_base_el;
  const background_color_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "rect"
  );
  background_color_el.setAttributeNS(null, "x", "0");
  background_color_el.setAttributeNS(null, "y", "0");
  background_color_el.setAttributeNS(null, "width", "0");
  background_color_el.setAttributeNS(null, "height", "0");
  background_color_el.setAttributeNS(null, "fill", "#FFFFFF");
  background_color_el.setAttributeNS(null, "stroke", "none");
  background_color_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "background-color";
  background_layer_el.appendChild(background_color_el);
  self._background_color_el = background_color_el;
  const background_image_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "image"
  );
  background_image_el.setAttributeNS(null, "x", "0");
  background_image_el.setAttributeNS(null, "y", "0");
  background_image_el.setAttributeNS(null, "width", "0");
  background_image_el.setAttributeNS(null, "height", "0");
  background_image_el.setAttributeNS(null, "stroke", "none");
  background_image_el.setAttributeNS(
    null,
    "preserveAspectRatio",
    "xMidYMid slice"
  );
  background_image_el.style.display = "none";
  background_image_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "background-image";
  background_layer_el.appendChild(background_image_el);
  self._background_image_el = background_image_el;
  const selector_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  selector_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "selector-path";
  selector_path_el.style.cursor = "grabbing";
  selector_path_el.setAttributeNS(null, "fill", "transparent");
  selector_path_el.setAttributeNS(null, "stroke", "#b2d7ff");
  selector_path_el.setAttributeNS(null, "stroke-width", "1");
  selector_path_el.setAttributeNS(null, "opacity", "0.5");
  canvas_el.appendChild(selector_path_el);
  self._selector_path_el = selector_path_el;
  const selector_nw_circle_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  selector_nw_circle_el.innerHTML = html`
    <circle
      style="cursor: grabbing;"
      cx="0"
      cy="0"
      r="10"
      fill="${makeActiveColor()}"
      stroke="#FFFFFF"
      stroke-width="1"
    />
  `;
  selector_nw_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-nw";
  canvas_el.appendChild(selector_nw_circle_el);
  self._selector_nw_circle_el = selector_nw_circle_el;
  const selector_n_circle_el = selector_nw_circle_el.cloneNode(true);
  selector_n_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-n";
  canvas_el.appendChild(selector_n_circle_el);
  self._selector_n_circle_el = selector_n_circle_el;
  const selector_ne_circle_el = selector_nw_circle_el.cloneNode(true);
  selector_ne_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-ne";
  canvas_el.appendChild(selector_ne_circle_el);
  self._selector_ne_circle_el = selector_ne_circle_el;
  const selector_e_circle_el = selector_nw_circle_el.cloneNode(true);
  selector_e_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-e";
  canvas_el.appendChild(selector_e_circle_el);
  self._selector_e_circle_el = selector_e_circle_el;
  const selector_se_circle_el = selector_nw_circle_el.cloneNode(true);
  selector_se_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-se";
  canvas_el.appendChild(selector_se_circle_el);
  self._selector_se_circle_el = selector_se_circle_el;
  const selector_s_circle_el = selector_nw_circle_el.cloneNode(true);
  selector_s_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-s";
  canvas_el.appendChild(selector_s_circle_el);
  self._selector_s_circle_el = selector_s_circle_el;
  const selector_sw_circle_el = selector_nw_circle_el.cloneNode(true);
  selector_sw_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-sw";
  canvas_el.appendChild(selector_sw_circle_el);
  self._selector_sw_circle_el = selector_sw_circle_el;
  const selector_w_circle_el = selector_nw_circle_el.cloneNode(true);
  selector_w_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-w";
  canvas_el.appendChild(selector_w_circle_el);
  self._selector_w_circle_el = selector_w_circle_el;
  const selector_r_circle_el = selector_nw_circle_el.cloneNode(true);
  selector_r_circle_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-circle-r";
  canvas_el.appendChild(selector_r_circle_el);
  self._selector_r_circle_el = selector_r_circle_el;
  const rubber_band_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  rubber_band_el.setAttributeNS(null, "fill", makeActiveColor2());
  rubber_band_el.setAttributeNS(null, "stroke", "#b2d7ff");
  rubber_band_el.setAttributeNS(null, "stroke-width", "1");
  rubber_band_el.setAttributeNS(null, "vector-effect", "non-scaling-stroke");
  rubber_band_el.setAttributeNS(null, "opacity", "0.5");
  rubber_band_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "rubber-band";
  rubber_band_layer_el.appendChild(rubber_band_el);
  self._rubber_band_el = rubber_band_el;
  const path_editor_line_container_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  path_editor_line_container_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "path-editor-line-container";
  path_editor_layer_el.appendChild(path_editor_line_container_el);
  self._path_editor_line_container_el = path_editor_line_container_el;
  const path_editor_point_container_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  path_editor_point_container_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "path-editor-point-container";
  path_editor_layer_el.appendChild(path_editor_point_container_el);
  self._path_editor_point_container_el = path_editor_point_container_el;
};
